/* global GLOBAL_PROMO_COOKIE_KEY */

import { cookie } from 'redux-effects-cookie'

export const getGlobalPromoCookie = async (dispatch) => ({ 'value': await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY))})

export const setGlobalPromoCookie = async (dispatch, value) => {
    await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY, value))
}
